import React from "react";
import "../../styles/TopInstructors.css";
import { getMentor } from "../../api/contentApi";
import ApiContentState from "../common/ApiContentState";

export default function TopInstructors({ mentor, showCta = true, onCtaClick }) {
  const [apiMentor, setApiMentor] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [loadError, setLoadError] = React.useState("");

  React.useEffect(() => {
    getMentor()
      .then((item) => setApiMentor(item))
      .catch((error) => {
        console.error("Unable to load mentor profile:", error);
        setLoadError("Unable to load mentor information.");
      })
      .finally(() => setIsLoading(false));
  }, []);

  const normalizedMentor = apiMentor
    ? {
        ...apiMentor,
        skillsTaught: apiMentor.skills
          ? apiMentor.skills.split(',').map((skill) => skill.trim()).filter(Boolean)
          : [],
      }
    : mentor;
  const mentorData = normalizedMentor;

  const handleCta = () => {
    if (onCtaClick) onCtaClick();
    else window.location.hash = "#courses";
  };

  return (
    <section className="instructors-section-wrapper">
      <div className="instructors-max-container">
        {isLoading || loadError || !mentorData ? (
          <ApiContentState
            loading={isLoading}
            error={loadError}
            emptyMessage="Mentor information is not available right now."
          />
        ) : (
          <>
        {/* SECTION HEADER */}
        <div className="instructors-header-row">
          <div className="instructors-left-headings">
            <span className="instructors-top-tag">MEET YOUR MENTOR</span>
            <h2 className="instructors-main-title">Learn Everything From {mentorData.name}</h2>
            <p className="instructors-subtitle">
              Master content creation, video editing, and audience growth directly from an industry veteran.
            </p>
          </div>
        </div>

        {/* FEATURED SINGLE MENTOR HERO CARD */}
        <div className="single-mentor-hero-card">
          <div className="mentor-avatar-column">
            <div className="mentor-image-wrapper">
              <img
                src={mentorData.avatar}
                alt={mentorData.name}
                className="mentor-profile-img"
              />
              <div className="mentor-experience-badge">
                <span>⏱️ {mentorData.experience}</span>
              </div>
            </div>
          </div>

          <div className="mentor-info-column">
            <div className="mentor-title-block">
              <div className="mentor-name-row">
                <h3 className="mentor-name">{mentorData.name}</h3>
                <span className="mentor-verified-badge" title="Verified Mentor">
                  ✓ Verified
                </span>
              </div>
              <p className="mentor-role">{mentorData.title}</p>
            </div>

            {mentorData.achievements && (
              <div className="mentor-achievement-banner">
                🏆 {mentorData.achievements}
              </div>
            )}

            {/* KEY METRICS GRID */}
            <div className="mentor-stats-grid">
              <div className="mentor-stat-item">
                <h4>{mentorData.subscribers}</h4>
                <p>Social Following</p>
              </div>
              <div className="mentor-stat-item">
                <h4>{mentorData.views}</h4>
                <p>Total Reach</p>
              </div>
              <div className="mentor-stat-item">
                <h4>{mentorData.channels}</h4>
                <p>Managed Channels</p>
              </div>
            </div>

            {/* SKILLS TAUGHT CHIPS */}
            {mentorData.skillsTaught && mentorData.skillsTaught.length > 0 && (
              <div className="mentor-skills-section">
                <span className="skills-label">What You'll Learn:</span>
                <div className="skills-chips-row">
                  {mentorData.skillsTaught.map((skill, index) => (
                    <span key={index} className="skill-chip">
                      ✓ {skill}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {/* CTA ACTION */}
            {showCta && (
              <div className="mentor-action-row">
                <button
                  className="btn-primary-enroll-mentor"
                  onClick={handleCta}
                >
                  Start Learning with {mentorData.name} ➔
                </button>
              </div>
            )}
          </div>
        </div>
          </>
        )}
      </div>
    </section>
  );
}